export default "__VITE_ASSET__BA2BkZTL__"